import React, { useContext, useEffect } from 'react'
import { Link } from 'react-scroll';
import { MyContext } from '../App';
import { MyAlert } from '../hooks/MyCostumeAlert';
import { motion } from "framer-motion";

export default function Navbar() {
    const { Lang, setLang } = useContext(MyContext);

    useEffect(() => {
        if (Lang === "Ar") {
            MyAlert("info", "I'm sorry for any confusion, but the Arabic version isn't formatted correctly. If you're having trouble understanding it, please don't hesitate to let me know.");
        }
    }, [Lang])
    return (
        <div className='py-4 md:py-7 px-6 md:px-20 flex gap-3 flex-wrap md:flex-row justify-between items-center md:items-start'>
            <motion.div initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.3 }} className='text-lg font-bold text-white whitespace-nowrap uppercase' >
                {Lang === 'Ar' ? '..رمز' : '..code'}
            </motion.div>

            <motion.div initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.5 }} className='flex gap-2'>
                <img title='English' onClick={() => setLang("Eng")} src="https://cdn2.iconfinder.com/data/icons/world-flag-icons/128/Flag_of_United_Kingdom.png" alt="Eng"
                    className={`w-6 h-6 inline-flex transition-all duration-500 ${Lang !== 'Eng' && 'opacity-20  hover:scale-110 hover:opacity-50'}`} />
                <img title='Francais' onClick={() => setLang("Fr")} src="https://cdn2.iconfinder.com/data/icons/world-flag-icons/128/Flag_of_France.png" alt="Fr"
                    className={`w-6 h-6 inline-flex  transition-all duration-500 ${Lang !== 'Fr' && 'opacity-20 hover:scale-110 hover:opacity-50'}`} />
                <img title='العربية' onClick={() => setLang("Ar")} src="https://cdn0.iconfinder.com/data/icons/world-flags-1/600/Palestine-2-512.png" alt="Ar"
                    className={`w-6 h-6 inline-flex  transition-all duration-500 ${Lang !== 'Ar' && 'opacity-20 hover:scale-110 hover:opacity-50'}`} />
            </motion.div>

            <div className="flex flex-wrap md:flex-col space-x-4 gap-2 items-center justify-center">
                <motion.div initial={{ scale: 0, }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.6 }} >
                    <Link to="home" smooth={true} duration={500} className="text-xs md:text-sm font-normal text-white text-center uppercase underline underline-offset-4">
                        {Lang === 'Ar' ? 'الرئيسية' : (Lang === 'Fr' ? 'Accueil' : 'Home')}
                    </Link>
                </motion.div>
                <motion.div initial={{ scale: 0, }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.8 }} >
                    <Link to="projects" smooth={true} duration={700} className="text-xs md:text-sm font-normal text-white text-center uppercase link">
                        {Lang === 'Ar' ? 'مشاريعي' : (Lang === 'Fr' ? 'MES PROJETS' : 'MY PROJECTS')}
                    </Link>
                </motion.div>
                <motion.div initial={{ scale: 0, }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 1 }} >
                    <Link to="skills" smooth={true} duration={900} className="text-xs md:text-sm font-normal text-white text-center uppercase link">
                        {Lang === 'Ar' ? 'مهاراتي' : (Lang === 'Fr' ? 'Mes Compétences' : 'MY SKILLS')}
                    </Link>
                </motion.div>
                <motion.div initial={{ scale: 0, }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 1.2 }} >
                    <Link to="aboutme" smooth={true} duration={1000} className="text-xs md:text-sm font-normal text-white  text-center uppercase link">
                        {Lang === 'Ar' ? 'حولي' : (Lang === 'Fr' ? 'À Propos' : 'ABOUT ME')}
                    </Link>
                </motion.div>
                <motion.div initial={{ scale: 0, }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 1.4 }} >
                    <Link to="faq" smooth={true} duration={1100} className="text-xs md:text-sm font-normal text-white  text-center uppercase link">
                        {Lang === 'Ar' ? 'حولي' : (Lang === 'Fr' ? 'À Propos' : 'Faq')}
                    </Link>
                </motion.div>
                <motion.div initial={{ scale: 0, }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 1.6 }} >
                    <Link to="contact" smooth={true} duration={1600} className="text-xs md:text-sm font-normal text-white  text-center uppercase link">
                        {Lang === 'Ar' ? 'اتصل بي' : (Lang === 'Fr' ? 'Contactez-moi' : 'CONTACT ME')}
                    </Link>
                </motion.div>
            </div>
        </div>
    )
}
